/* mc-header-guard.js — keeps exactly one header on the page.

   layout/theme.liquid renders the header directly, because
   sections/header-group.json is owned by the theme editor on this live
   theme and silently drops pushes from GitHub. Liquid in the layout is
   the one route that works.

   The moment somebody reconciles the group in the editor, the real
   header starts rendering and the fallback has to go: two headers is a
   worse bug than the missing one it solved, and it would appear the
   instant the shop does the right thing.

   (The home page no longer needs a guard: since 2026-10-08 the layout
   renders the whole home page and does not print content_for_layout
   there, so nothing from templates/index.json can appear twice.)

   Note on selectors: an earlier revision asked for
   '.bh-header:not([data-mc-header-fallback] .bh-header)'. A :not()
   carrying a descendant combinator is Selectors Level 4 — older engines
   throw SyntaxError, and a throw here takes the whole guard down, so the
   browsers least able to cope would have been the ones shown two
   headers. Plain containment instead, which every engine has. */

(function headerGuard() {
  'use strict';

  var fallback = document.querySelector('[data-mc-header-fallback]');
  if (!fallback) return;

  var headers = document.querySelectorAll('.bh-header, .bh-utility-bar, [id*="header-group"]');
  for (var i = 0; i < headers.length; i++) {
    /* A header rendered by the section group sits outside this wrapper. */
    if (!fallback.contains(headers[i])) {
      fallback.parentNode.removeChild(fallback);
      return;
    }
  }
})();
